import script from "./AppToolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppToolbar.vue?vue&type=script&lang=ts&setup=true"

import "./AppToolbar.vue?vue&type=style&index=0&id=1f9afeda&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9afeda"]])

export default __exports__